import { useAuthStore } from "@/stores/useAuthStore";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const useAuthGuard = () => {
  const token = useAuthStore((s) => s.token);
  const isRehydrated = useAuthStore((s) => s.hasHydrated);
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect after rehydration is complete
    if (isRehydrated && !token) {
      navigate({ to: "/auth/signin", replace: true });
    }
  }, [token, navigate, isRehydrated]);

  // A token is enough to consider the user signed in; profile hydration can lag behind.
  const isAuthenticated = Boolean(token) && isRehydrated;

  return { isAuthenticated, isRehydrated };
};
